import { Face, Groups, Equalizer, ManageAccounts, Diversity3, Face4 } from '@mui/icons-material';

import { ENTITY_KEY } from '_config/permissions';

// STUDENT: 0,
// MONITOR: 1,
// SECRETARY: 2,
// CHAIRMAN: 3,
// ADVISER: 4,
// DEPARTMENT: 5,
// ADMIN: 6,

export const NAVIGATIONS = {
	0: [
		{
			id: 'student',
			title: 'Sinh viên',
			type: 'collapse',
			icon: Face,
			entity: ENTITY_KEY.STUDENT.key,
			children: [
				{
					id: 'student-sheets',
					title: 'Điểm rèn luyện của tôi',
					type: 'item',
					path: '/student-sheets',
					entity: ENTITY_KEY.STUDENT.key,
					breadcrumbs: false,
				},
				{
					id: 'student-history',
					title: 'Lịch sử điểm rèn luyện của tôi',
					type: 'item',
					path: '/student-history',
					entity: ENTITY_KEY.STUDENT.key,
					breadcrumbs: false,
				},
			],
		},
	],
	1: [
		{
			id: 'student',
			title: 'Sinh viên',
			type: 'collapse',
			icon: Face,
			entity: ENTITY_KEY.CLASS.key,
			children: [
				{
					id: 'student-sheets',
					title: 'Điểm rèn luyện của tôi',
					type: 'item',
					path: '/student-sheets',
					entity: ENTITY_KEY.CLASS.key,
					breadcrumbs: false,
				},
				{
					id: 'student-history',
					title: 'Lịch sử điểm rèn luyện của tôi',
					type: 'item',
					path: '/student-history',
					entity: ENTITY_KEY.CLASS.key,
					breadcrumbs: false,
				},
			],
		},
		{
			id: 'class',
			title: 'Lớp trưởng',
			type: 'collapse',
			icon: Face4,
			entity: ENTITY_KEY.CLASS.key,
			children: [
				{
					id: 'class-sheets',
					title: 'Điểm rèn luyện của lớp',
					type: 'item',
					path: '/class/sheets',
					entity: ENTITY_KEY.CLASS.key,
					breadcrumbs: false,
				},
				{
					id: 'class-history',
					title: 'Lịch sử điểm rèn luyện của lớp',
					type: 'item',
					path: '/class/history',
					entity: ENTITY_KEY.CLASS.key,
					breadcrumbs: false,
				},
			],
		},
	],
	2: [
		{
			id: 'student',
			title: 'Sinh viên',
			type: 'collapse',
			icon: Face,
			entity: ENTITY_KEY.CLASS.key,
			children: [
				{
					id: 'student-sheets',
					title: 'Điểm rèn luyện của tôi',
					type: 'item',
					path: '/student-sheets',
					entity: ENTITY_KEY.CLASS.key,
					breadcrumbs: false,
				},
				{
					id: 'student-history',
					title: 'Lịch sử điểm rèn luyện của tôi',
					type: 'item',
					path: '/student-history',
					entity: ENTITY_KEY.CLASS.key,
					breadcrumbs: false,
				},
			],
		},
		{
			id: 'class',
			title: 'Lớp trưởng',
			type: 'collapse',
			icon: Face4,
			entity: ENTITY_KEY.CLASS.key,
			children: [
				{
					id: 'class-sheets',
					title: 'Điểm rèn luyện của lớp',
					type: 'item',
					path: '/class/sheets',
					entity: ENTITY_KEY.CLASS.key,
					breadcrumbs: false,
				},
				{
					id: 'class-history',
					title: 'Lịch sử điểm rèn luyện của lớp',
					type: 'item',
					path: '/class/history',
					entity: ENTITY_KEY.CLASS.key,
					breadcrumbs: false,
				},
			],
		},
	],
	3: [
		{
			id: 'student',
			title: 'Sinh viên',
			type: 'collapse',
			icon: Face,
			entity: ENTITY_KEY.CLASS.key,
			children: [
				{
					id: 'student-sheets',
					title: 'Điểm rèn luyện của tôi',
					type: 'item',
					path: '/student-sheets',
					entity: ENTITY_KEY.CLASS.key,
					breadcrumbs: false,
				},
				{
					id: 'student-history',
					title: 'Lịch sử điểm rèn luyện của tôi',
					type: 'item',
					path: '/student-history',
					entity: ENTITY_KEY.CLASS.key,
					breadcrumbs: false,
				},
			],
		},
		{
			id: 'class',
			title: 'Lớp trưởng',
			type: 'collapse',
			icon: Face4,
			entity: ENTITY_KEY.CLASS.key,
			children: [
				{
					id: 'class-sheets',
					title: 'Điểm rèn luyện của lớp',
					type: 'item',
					path: '/class/sheets',
					entity: ENTITY_KEY.CLASS.key,
					breadcrumbs: false,
				},
				{
					id: 'class-history',
					title: 'Lịch sử điểm rèn luyện của lớp',
					type: 'item',
					path: '/class/history',
					entity: ENTITY_KEY.CLASS.key,
					breadcrumbs: false,
				},
			],
		},
	],
	4: [
		{
			id: 'adviser',
			title: 'Cố vấn học tập',
			type: 'collapse',
			icon: Groups,
			entity: ENTITY_KEY.ADVISER.key,
			children: [
				{
					id: 'adviser',
					title: 'Điểm rèn luyện của lớp',
					type: 'item',
					path: '/adviser/sheets',
					entity: ENTITY_KEY.ADVISER.key,
					breadcrumbs: false,
				},
				{
					id: 'adviser-history',
					title: 'Lịch sử điểm rèn luyện của lớp',
					type: 'item',
					path: '/adviser/history',
					entity: ENTITY_KEY.ADVISER.key,
					breadcrumbs: false,
				},
			],
		},
		{
			id: 'report',
			title: 'Thống kê',
			type: 'collapse',
			icon: Equalizer,
			entity: ENTITY_KEY.ADVISER.key,
			children: [
				{
					id: 'report',
					title: 'Thống kê phiếu',
					type: 'item',
					path: '/adviser/report',
					entity: ENTITY_KEY.ADVISER.key,
				},
			],
		},
		{
			id: 'general',
			title: 'Quản lý chung',
			type: 'collapse',
			icon: ManageAccounts,
			entity: ENTITY_KEY.ADVISER.key,
			children: [
				{
					id: 'role',
					title: 'Quản lý phân quyền',
					type: 'item',
					path: '/adviser/role',
					entity: ENTITY_KEY.ADVISER.key,
				},
			],
		},
	],
	5: [
		{
			id: 'department',
			title: 'Khoa',
			type: 'collapse',
			icon: Groups,
			entity: ENTITY_KEY.DEPARTMENT.key,
			children: [
				{
					id: 'department',
					title: 'Điểm rèn luyện của khoa',
					type: 'item',
					path: '/department/sheets',
					entity: ENTITY_KEY.DEPARTMENT.key,
					breadcrumbs: false,
				},
				{
					id: 'department-history',
					title: 'Lịch sử điểm rèn luyện của khoa',
					type: 'item',
					path: '/department/history',
					entity: ENTITY_KEY.DEPARTMENT.key,
					breadcrumbs: false,
				},
			],
		},
		{
			id: 'report',
			title: 'Thống kê',
			type: 'collapse',
			icon: Equalizer,
			entity: ENTITY_KEY.DEPARTMENT.key,
			children: [
				{
					id: 'report',
					title: 'Thống kê phiếu',
					type: 'item',
					path: '/department/report',
					entity: ENTITY_KEY.DEPARTMENT.key,
				},
			],
		},
	],
	6: [
		{
			id: 'rlsv',
			title: 'Rèn luyện sinh viên',
			type: 'collapse',
			icon: Diversity3,
			entity: ENTITY_KEY.ADMIN.key,
			children: [
				{
					id: 'rlsv-forms',
					title: 'Quản lý biểu mẫu',
					type: 'item',
					path: '/admin/forms',
					entity: ENTITY_KEY.ADMIN.key,
				},
				{
					id: 'rlsv-sheets',
					title: 'Quản lý phiếu đánh giá',
					type: 'item',
					path: '/admin/sheets',
					entity: ENTITY_KEY.ADMIN.key,
				},
				{
					id: 'rlsv-history',
					title: 'Lịch sử phiếu đánh giá',
					type: 'item',
					path: '/admin/history',
					entity: ENTITY_KEY.ADMIN.key,
				},
			],
		},
		{
			id: 'report',
			title: 'Thống kê',
			type: 'collapse',
			icon: Equalizer,
			entity: ENTITY_KEY.ADMIN.key,
			children: [
				{
					id: 'report',
					title: 'Thống kê phiếu',
					type: 'item',
					path: '/admin/report',
					entity: ENTITY_KEY.ADMIN.key,
				},
				{
					id: 'errors-report',
					title: 'Thống kê lỗi upload',
					type: 'item',
					path: '/admin/errors-report',
					entity: ENTITY_KEY.ADMIN.key,
				},
			],
		},
		{
			id: 'general',
			title: 'Quản lý chung',
			type: 'collapse',
			icon: ManageAccounts,
			entity: ENTITY_KEY.ADMIN.key,
			children: [
				{
					id: 'general-students',
					title: 'Danh sách sinh viên',
					type: 'item',
					path: '/admin/students',
					entity: ENTITY_KEY.ADMIN.key,
				},
				{
					id: 'general-advisers',
					title: 'Danh sách cố vấn học tập',
					type: 'item',
					path: '/admin/advisers',
					entity: ENTITY_KEY.ADMIN.key,
				},
				{
					id: 'general-departments',
					title: 'Danh sách tài khoản khoa',
					type: 'item',
					path: '/admin/departments',
					entity: ENTITY_KEY.ADMIN.key,
				},
				{
					id: 'general-setting',
					title: 'Học kỳ-Năm học',
					type: 'item',
					path: '/admin/setting',
					entity: ENTITY_KEY.ADMIN.key,
				},
			],
		},
	],
};
